import React, { createContext, useState, useContext } from "react";
import { useTranslation } from "react-i18next";


const TabsContext = createContext();

export default function TabsProvider({ children, tempDashboard, setTempDashboard}) {
  
    const [activeTabIndex, setActiveTabIndex] = useState(0);
    const { t } = useTranslation();

  
    async function handleNewTab(item) {
        const allDash = tempDashboard
          .filter(dashItem => dashItem !== null)
          .map(dashItem => {
            if (!dashItem.widgets) return { ...dashItem, widgets: [] };
            return dashItem;
          });

        if (!item && allDash.length !== 0 && allDash[allDash.length - 1].widgets.length === 0) return;

        const newId = allDash.length > 1 ? sortId(allDash) : allDash[0].id + 1;

        if (item) {
          if (allDash.length === 1 && allDash[0].widgets.length === 0) {
            setTempDashboard([
              {
                id: `${newId}`,
                name: item.label ? item.label : t('UNTITLED'),
                isNewDashboard: true,
                ordination: 1,
                widgets: item.widgets ?  item.widgets : []
              },
            ]);
            setActiveTabIndex(0);
            return;
          } else if (allDash[allDash.length - 1].widgets.length === 0) {
            allDash.splice(allDash.length - 1, 1)
          }

        }

       
        setTempDashboard([
          ...allDash,
          {
            id: `${newId}`,
            name: item ?  item.label : t('UNTITLED'),
            isNewDashboard: true,
            ordination: tempDashboard.length + 1,
            widgets: item && item.widgets ?  item.widgets : []
          },
        ]);
        setActiveTabIndex(allDash.length);
      }

    function sortId(dashboard) {
        return dashboard.reduce((prev, current) => {
        const prevId = parseInt(prev.id);
        const currentId = parseInt(current.id);
        return prevId > currentId ? prevId + 1 : currentId + 1;
        });
    }

  return (
    <TabsContext.Provider
      value={{
        activeTabIndex,
        setActiveTabIndex,
        handleNewTab
      }}
    >
      {children}
    </TabsContext.Provider>
  );
}

export function useTabs() {
  const { activeTabIndex, setActiveTabIndex, handleNewTab } = useContext(TabsContext);;
  return { activeTabIndex, setActiveTabIndex, handleNewTab  };
}